import { Box, Card, Stack, Typography, useMediaQuery } from '@mui/material'
import { CardFiltration, FiltrationAutocomplete, FiltrationText } from './style'
import { FormBlock } from '../../../common/FormGenerator'
import { getFormConfig } from './settingsConfig'
import { PureLightTheme } from '../../../styles/theme'

export const GrowthToolsFiltration = () => {
  const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('md'));

  return (
    <Card variant='primaryCard' sx={CardFiltration}>
      {!isMobile && (
        <Box mb={{ md: 2.5 }}>
          <FormBlock formFieldConfig={getFormConfig('search')} />
        </Box>
      )}
      <Typography variant='h4' sx={FiltrationText}>Источник:</Typography>
      <Box sx={FiltrationAutocomplete}>
        <FormBlock formFieldConfig={getFormConfig('authorGrowthTool')} />
      </Box>
      <Typography variant='h4' sx={FiltrationText}>Тип контента:</Typography>
      <Stack>
        <FormBlock formFieldConfig={getFormConfig('growthToolFocus')} />
      </Stack>
    </Card>
  )
}
